(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 167,
                    parameters: parms || {}
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 168,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 178,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
